import React from 'react';
import { Badge } from '@frontend/shadcn/components/ui/badge';
import { HashtagIcon, CameraIcon } from '@revfluence/fresh-icons/solid/esm';
import { InstagramIcon, TiktokIcon, YoutubeIcon, PinterestIcon } from '@revfluence/fresh-icons/brands/esm';
import { DEFAULT_AVAILABILITY_ITEMS } from '../../RecruitmentContext';
import { ViewMode } from '../../constants';

interface AvailabilityItem {
  text: string;
  checked?: boolean;
}

interface AvailabilityProps {
  view: ViewMode;
  title?: string;
  availability: AvailabilityItem[];
  backgroundColor?: string;
  titleColor?: string;
  titleFontSize?: number;
  titleFontFamily?: string;
}

function getAvailabilityIcon(itemText: string) {
  const itemFromDefault = DEFAULT_AVAILABILITY_ITEMS.find((item) => item === itemText);
  if (itemFromDefault === 'Instagram') return <InstagramIcon className="w-4 h-4" />;
  if (itemFromDefault === 'TikTok') return <TiktokIcon className="w-4 h-4" />;
  if (itemFromDefault === 'YouTube') return <YoutubeIcon className="w-4 h-4" />;
  if (itemFromDefault === 'Pinterest') return <PinterestIcon className="w-4 h-4" />;
  if (itemFromDefault === 'User Generated Content (UGC)') return <CameraIcon className="w-4 h-4" />;
  return <HashtagIcon className="w-4 h-4" />;
}

export function Availability({
  view,
  title = 'Available For',
  availability,
  backgroundColor = '#e11d48',
  titleColor = 'white',
  titleFontSize = 28,
  titleFontFamily = 'Inter, sans-serif',
}: AvailabilityProps) {
  const titleStyle = {
    color: titleColor,
    fontSize: titleFontSize,
    fontFamily: titleFontFamily,
    fontWeight: 600,
  };

  const isDesktop = view === ViewMode.DESKTOP;

  const checkedAvailability = availability.filter((item) => item.checked);

  if (checkedAvailability.length === 0) {
    return null;
  }

  return (
    <div
      className={`w-full ${isDesktop ? 'py-16 px-8' : 'py-12 px-4'}`}
      style={{ backgroundColor }}
    >
      <div className={`${isDesktop ? 'max-w-6xl' : 'max-w-md'} mx-auto`}>
        <h2 className={`${isDesktop ? 'text-4xl' : 'text-2xl'} font-semibold mb-8 text-center`} style={titleStyle}>
          {title}
        </h2>

        <div className="flex flex-wrap gap-3 justify-center">
          {checkedAvailability.map((item, idx) => (
            <Badge
              key={idx}
              variant="secondary"
              className="flex items-center gap-2"
            >
              {getAvailabilityIcon(item.text)}
              <span>{item.text}</span>
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
}
